<template>
  <div class="leave-temp leave-temp-form w-100">
    <div class="grid leave-temp__top">
      <div class="grid-item">
        <review-area
          :form-data="formData"
          :filter-type="1"
          :status="'teacherStatus'"
          :opinion="'teacherOpinion'"
          :user-name="'teacherUserName'"
          :sign-time="'teacherTime'"
        >
          <template v-slot:title>
            <div>辅导员意见：</div>
<!--            <div>（与家长联系情况；是否同意其子女出校园；是否有相关证明材料）</div>-->
          </template>
        </review-area>
      </div>
      <div class="grid-item">
        <review-area
          title="学院学生办公室核批意见"
          :form-data="formData"
          :filter-type="2"
          :status="'subCollegeStatus'"
          :opinion="'subCollegeOpinion'"
          :user-name="'subCollegeUserName'"
          :sign-time="'subCollegeTime'"
        />
      </div>
    </div>
    <div class="grid leave-temp__center">
      <div class="grid-item" v-for="item in filterTypeMapList.slice(2,5)" :key="item.filterType">
        <review-area
          :title="item.formLabel"
          :filter-type="item.filterType"
          :form-data="formData"
          :status="item.statusKey"
          :opinion="item.editKey+'Opinion'"
          :user-name="item.editKey+'UserName'"
          :sign-time="item.editKey+'Time'"
        />
      </div>
    </div>
    <div class="grid leave-temp__bottom">
      <div class="grid-item">
        销假时间：
        <span style="font-size: 15px;"><i style="padding-left: 2em;"></i>年<i style="padding-left: 2em;"></i>月<i
          style="padding-left: 2em;"></i>日<i style="padding-left: 2em;"></i>时<i
          style="padding-left: 2em;"></i>分</span>
      </div>
      <div class="grid-item font-right">
        辅导员
      </div>
      <div class="grid-item">
      </div>
    </div>
  </div>
</template>

<script>

import dialog from '@/vue/mixins/dialog'
import ReviewArea from '@/views/pages/secondCollege/leave-out/component/reviewArea.vue'
import { Decimal } from 'decimal.js'

export default {
  components: { ReviewArea },
  mixins: [dialog],
  props: {
    filterTypeMapList: {
      type: Array,
      default: () => ([])
    },
    formData: {
      type: Object,
      default: () => ({
        teacherStatus: null,
        schStatus: null,
        filterType: 0
      })
    }
  },
  data() {
    return {}
  },
  methods: {
    Decimal
  }
}
</script>
<style lang="scss">
.leave-temp-form {

}

</style>
